import { Component, Inject, OnInit, OnDestroy, HostListener  } from '@angular/core';
import { LoaderService } from './core/services/loader.service';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router
} from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  RedirectRequest
} from '@azure/msal-browser';
import { filter, Subject } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { Title } from '@angular/platform-browser';
import { TokenState } from './models/auth.model';
import { IdleTimeoutService } from './core/services/idle-timeout.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  loginDisplay = false;
  tokenExpiration = '';
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private title: Title,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private userService: AuthService,
    private idleTimeoutService: IdleTimeoutService
  ) {}

  @HostListener('document:mousemove')
  @HostListener('document:keydown')
  @HostListener('document:mousedown')
  onUserActivity(): void {
    this.idleTimeoutService.resetTimer();
  }

  ngOnInit(): void {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe(async (result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
        const tokenState: TokenState = {
          token: payload.accessToken,
          expTime: payload.expiresOn!
        };
        this.userService.$msaltoken.set(tokenState);
        this.userService.setAuthDetais(payload.account);
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loaderService.showLoader();
      } else if (event instanceof NavigationEnd) {
        this.loaderService.hideLoader();
      }
    });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  // Log the user in and redirect them if MSAL provides a redirect URI otherwise go to the default URI
  login() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({
        ...this.msalGuardConfig.authRequest
      } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  // Log the user out
  logout() {
    this.authService.logoutRedirect();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
